module.exports = __webpack_public_path__ + "img/sec_in1.e3ed3a76.jpg";